/* @flow */

import {
  isUndefined, isNull, findLast,
} from 'lodash/fp';
import dayjs from 'dayjs';


const selectSetting = (settingName: string) => (state: AppState) => {
  const { offline, settings } = state,
        syncedState = settings[settingName],
        offlineAction = findLast(
          ({ type, payload }) => type === 'UPDATE_SETTING' && !isNull(payload[settingName]) && !isUndefined(payload[settingName]),
          offline.outbox,
        );

  return offlineAction
    ? offlineAction.payload[settingName]
    : syncedState;
};

export const startMorningsAtSelector = selectSetting('startMorningsAtMinuteOffset');

export const startEveningsAtSelector = selectSetting('startEveningsAtMinuteOffset');

export const laterTodayDelayMinutesSelector = selectSetting('laterTodayDelayMinutes');

export const lastPostponedDateSelector = (state: AppState) => {
  const setting = selectSetting('lastPostponedDate')(state);
  return setting ? dayjs(setting) : null;
};
